<template>
    <CollapsibleWidget>
        <template #name>Languages</template>

        <template #controls>
            <Badge
                v-if="creativeLibraryFiltersStore.selectedLanguages.length"
                :count="creativeLibraryFiltersStore.selectedLanguages.length"
                class="filter-badge-count"
            />
        </template>

        <LibraryCheckboxGroup v-model="creativeLibraryFiltersStore.selectedLanguages" :options="options" />
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useStore } from "vuex";

import LibraryCheckboxGroup from "@/components/Campaign/LibraryCheckboxGroup.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";
import type { RootState } from "@/store/types";

const store = useStore<RootState>();
const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();

const options = computed(() => store.state.deliverableLibrary.filterOptions.languages);
</script>
